const bigScreen = [{top: 25, right: 70, bottom: 25, left: 15},
                    {top: 25, right: 60, bottom: 25, left: 10},
                    {top: 25, right: 80, bottom: 25, left: 10}]

const mediumScreen = [{top: 25, right: 50, bottom: 25, left: 15},
                    {top: 25, right: 50, bottom: 25, left: 10},
                    {top: 25, right: 25, bottom: 25, left: 10}]

const smallScreen = [{top: 25, right: 30, bottom: 25, left: 15},
                    {top: 25, right: 25, bottom: 25, left: 10},
                    {top: 25, right: 10, bottom: 25, left: 10}]      
    
export { bigScreen, smallScreen, mediumScreen }